import { render, staticRenderFns } from "./CardMobileExpert.vue?vue&type=template&id=0f397a13&scoped=true&"
import script from "./CardMobileExpert.vue?vue&type=script&lang=js&"
export * from "./CardMobileExpert.vue?vue&type=script&lang=js&"
import style0 from "./CardMobileExpert.vue?vue&type=style&index=0&id=0f397a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f397a13",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f397a13')) {
      api.createRecord('0f397a13', component.options)
    } else {
      api.reload('0f397a13', component.options)
    }
    module.hot.accept("./CardMobileExpert.vue?vue&type=template&id=0f397a13&scoped=true&", function () {
      api.rerender('0f397a13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/mobile/CardMobileExpert.vue"
export default component.exports